import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { VolumeCard } from "../VolumeCard";
import { images, volumes } from "../../data/content";
export function VolumesSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-353" data-mp="2munas7hskjcb">
      <div className="mx-auto max-w-4xl" data-id="element-354" data-mp="2rtgn3wlce4aw">
        <SectionHeading eyebrow="What’s inside Shoulder Assessment Blueprint™?" title="6 practical volumes for a more organized assessment process" data-id="element-355" data-mp="2rs5ad79x5m7n" />
        <img src={images.mockup} alt="The six volumes of Shoulder Assessment Blueprint" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-356" data-mp="2iu3ef651ljr8" />
        <div className="mt-10 space-y-6" data-id="element-357" data-mp="292yzg6fd9ywe">
          {volumes.map(v => <VolumeCard key={v.label} volume={v} data-id="element-358" data-mp="2915uqwobdor1" />)}
        </div>
        <div className="mt-12" data-id="element-359" data-mp="1v4iryd9ok4d7">
          <CtaButton label="Yes! I want all 6 volumes" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-360" data-mp="1z52qnl9wjg1g" />
        </div>
      </div>
    </section>;
}